import React, { useState, useRef, useImperativeHandle } from 'react';
import { message, Spin } from 'antd';
import FormImageUpload from '../FormImageUpload/FormImageUpload';
import FormSaveCancelToolbar from '../FormSaveCancelToolbar/FormSaveCancelToolbar'; 
import usePatchCourseMutation from '../../gql/hooks/usePatchCourse';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import './styles.less';

const TabMedia = ( { form, isSavingCallback, ref } ) => {
    const heroImageRef = useRef(); 
    const thumbnailImageRef = useRef();
    const [ isSaving, setIsSaving ] = useState( false );
    const [ isModified, setIsModified ] = useState( false );
    const { saveCourse } = usePatchCourseMutation();
    const [ openConfirm, setOpenConfirm ] = useState( false );

    useImperativeHandle( ref, () => ( {
        isModified() {
            return isModified;
        },
        showSaveConfirm() {
            setOpenConfirm( true );
        }
    } ) );
   
    const handleSave = async () => {
        setIsSaving( true );
        isSavingCallback( true );
        setOpenConfirm( false );  
        
        await heroImageRef.current.save();
        await thumbnailImageRef.current.save();
 
        /*****************************
         * Patch Course
         *****************************/
    
        const response = await saveCourse( courseFormUtils.getCourseSaveData( form ) );
        
        if ( response.success ) { 
            if ( form.getFieldValue( 'heroImageIsModified' ) ) {
                form.setFieldsValue( { heroImage: form.getFieldValue( 'heroImageModified' ) } );
            }
            
            if ( form.getFieldValue( 'thumbnailImageIsModified' ) ) {
                form.setFieldsValue( { thumbnailImage: form.getFieldValue( 'thumbnailImageModified' ) } );
            }
            
            heroImageRef.current.reset();
            thumbnailImageRef.current.reset();
            message.success( 'Course saved.' );
        } else {
            message.error( 'Error saving course!' ); 
        }
    
        setIsSaving( false );
        isSavingCallback( false );
    };

    const handleReset = () => {
        heroImageRef.current.reset();
        thumbnailImageRef.current.reset();
        setOpenConfirm( false ); 
        isSavingCallback( false );
    };

    const handleModifiedChange = () => {
        const result = form.getFieldValue( 'heroImageIsModified' ) || 
            form.getFieldValue( 'thumbnailImageIsModified' );
        setIsModified( result );
    };

    return (
        <div className="media-tab tab-main-columns">
            <div className="left">
                <Spin spinning={ isSaving }>
                    <FormImageUpload 
                        form={ form }
                        ref={ heroImageRef }
                        name="Hero Image" 
                        type="heroImage"
                        modifiedCallback={ handleModifiedChange }
                    />
                
                    <FormImageUpload
                        form={ form }
                        ref={ thumbnailImageRef }
                        name="Thumbnail Image" 
                        type="thumbnailImage"
                        modifiedCallback={ handleModifiedChange }
                    />
                </Spin>
            </div>

            <div className="right">
                <FormSaveCancelToolbar
                    form={ form } 
                    open={ openConfirm }
                    saving={ isSaving }
                    modified={ isModified }
                    saveCallback={ handleSave }
                    cancelCallback={ handleReset }
                />
            </div>
        </div>
    );
};

export default TabMedia;
